import { axiosInstance } from ".";

export const getUsers = async (params) => {
  return await axiosInstance.get(`users`, { params });
};
